import React from 'react';

import styled, { css } from 'styled-components';

import useViewMode from 'hooks/common/useViewMode';

/**
 * @desc 필드 폼 컴포넌트로, 제목, 내용, 에러 메시지 및 추가적인 자식 요소들을 렌더링합니다.
 * @param {string} title - 필드 제목
 * @param {string} className - 필드 항목에 추가할 클래스명
 * @param {string} titleClassName  - 제목에 추가할 클래스명
 * @param {string} errorMessage - 에러 메시지
 * @param {React.ReactNode} children - 필드 내에 포함될 자식 요소
 * @param {number} min - 최소 값
 * @param {number} max - 최대 값
 * @param {React.ReactNode} button - 버튼 컴포넌트
 * @returns {JSX.Element} 필드 폼 컴포넌트
 */
const FieldForm = ({
  title,
  className = '',
  titleClassName = '',
  errorMessage = '',
  successMessage,
  children,
  min,
  max,
  button,
}) => {
  const { isMobile } = useViewMode();
  return (
    <FieldItem className={className}>
      {title && <FieldTitle className={titleClassName}>{title}</FieldTitle>}
      {(children || max || min) && (
        <AreaChild>
          <AreaChildInner>
            {children}
            {max > 0 && (
              <MaxLength className="max_length">
                ({min}/{max})
              </MaxLength>
            )}
            {errorMessage && (
              <ErrorMessage className="error_message">
                {errorMessage}
              </ErrorMessage>
            )}
            {!isMobile && successMessage}
          </AreaChildInner>
          {button && button}
        </AreaChild>
      )}
      {isMobile && successMessage}
    </FieldItem>
  );
};

export default FieldForm;

const FieldItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* width: 48.413%; */
  // width: 100%;

  &.detail_address {
    input {
      border: 0;
      padding: 0;
    }
  }

  &.ip_length {
    .max_length {
      right: 40px;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  &.w-full {
    width: 100%;
  }

  ${({ min }) =>
    min &&
    css`
      &:after {
        position: absolute;
        top: 2px;
        right: 48px;
        bottom: 2px;
        width: 24px;
        background: ${min
          ? 'none'
          : 'linear-gradient(90deg, rgba(255, 255, 255, 0), rgb(255, 255, 255))'};
        opacity: 1;
        transition: opacity 0.3s ease 0s;
        content: '';
      }
    `}
`;

const FieldTitle = styled.div`
  font-size: 15px;
  letter-spacing: -0.015px;
  font-weight: 500;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }

  &.necessary {
    ${({ theme }) => theme.necessary}
  }
`;

export const AreaChild = styled.div`
  position: relative;
  display: flex;
  gap: 6px;
`;

const MaxLength = styled.span`
  position: absolute;
  top: 10px;
  right: 12px;
  // transform: translateY(-50%);
  color: ${({ theme }) => theme.color.gray400};
  background: ${({ theme }) => theme.color.white};
  font-size: 12px;
  height: max-content;
`;

const ErrorMessage = styled.span`
  padding-left: 10px;
  padding-right: 5px;
  color: ${({ theme }) => theme.color.primary};
  font-size: 13px;
  font-weight: 300;
  background: ${({ theme }) => theme.color.white};
`;

export const AreaChildInner = styled.div`
  position: relative;
  width: 100%;
`;
